/** Dev-only: Lighthouse on `pnpm dev` is not representative (Vite HMR, per-component CSS). */
export default defineNuxtPlugin({
  name: 'lighthouse-dev-hint',
  setup() {
    if (!import.meta.dev) return
    console.info(
      '[lip-sync] Lighthouse Performance: use `pnpm build && pnpm preview` (not `pnpm dev`). See docs/lighthouse-baseline.md',
    )
  },
})
